import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { BILLING_CONFIG } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetBillingConfigByIdProps {
  pricingId: any;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBillingConfigById = async (communityId: string, pricingId: any) =>
  await axiosAuth.get(`${BILLING_CONFIG(communityId)}/${pricingId}`);

const useGetBillingConfigById = ({
  pricingId,
  communityId,
  queryParams,
}: UseGetBillingConfigByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-config", communityId, pricingId],
    queryFn: () => getBillingConfigById(communityId, pricingId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!pricingId && (queryParams?.enabled ?? true),
  });
};

export default useGetBillingConfigById;
